module.exports = __webpack_public_path__ + "img/product_27.080fbb6.webp";